/**
 * @desc: Copied from https://git.perkbox.io/backend-services/identity-v2/blob/master/internal/errorLib/codes.go
 */
var User;
(function (User) {
    User["UserNotFoundErr"] = "PBIDEUserNotFound";
    User["EmailAlreadyExists"] = "PBIDEEmailAlreadyExists";
    User["EmailTooShort"] = "PBIDEEmailTooShort";
    User["EmailTooLong"] = "PBIDEEmailTooLong";
    User["EmailInvalid"] = "PBIDEEmailInvalid";
    User["RoleHierarchyCheckFailed"] = "PBIDERoleHierarchyCheckFailed";
    User["InvalidSettingKey"] = "PBIDEInvalidSettingKey";
    User["InvalidSettingType"] = "PBIDEInvalidSettingType";
    User["AddressValidationFailed"] = "PBIDEAddressValidationFailed";
    User["OneAddressMustBePrimary"] = "PBIDEOneAddressMustBePrimary";
    User["OnlyOnePrimaryAddress"] = "PBIDEOnlyOnePrimaryAddress";
    User["DOBInvalid"] = "PBIDEDOBInvalid";
    User["FirstnameTooShort"] = "PBIDEFirstnameTooShort";
    User["FirstnameTooLong"] = "PBIDEFirstnameTooLong";
    User["FirstnameInvalid"] = "PBIDEFirstnameInvalid";
    User["LastnameTooShort"] = "PBIDELastnameTooShort";
    User["LastnameTooLong"] = "PBIDELastnameTooLong";
    User["LastnameInvalid"] = "PBIDELastnameInvalid";
    User["GenderInvalid"] = "PBIDEGenderInvalid";
    User["PhoneTooShort"] = "PBIDEPhoneTooShort";
    User["PhoneTooLong"] = "PBIDEPhoneTooLong";
    User["PhoneInvalid"] = "PBIDEPhoneInvalid";
    User["SourceInvalid"] = "PBIDESourceInvalid";
    User["ProfileImageInvalid"] = "PBIDEProfileImageInvalid";
    User["UserDisabled"] = "PBIDEUserDisabled";
    User["TeamNotFoundErr"] = "PBIDETeamNotFound";
    User["TeamDoesNotBelong"] = "PBIDETeamDoesNotBelong";
})(User || (User = {}));
export default User;
